import { render, staticRenderFns } from "./FeedEventCardUnAuth.vue?vue&type=template&id=edd7d958&scoped=true"
import script from "./FeedEventCardUnAuth.vue?vue&type=script&lang=js"
export * from "./FeedEventCardUnAuth.vue?vue&type=script&lang=js"
import style0 from "./FeedEventCardUnAuth.vue?vue&type=style&index=0&id=edd7d958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd7d958",
  null
  
)

export default component.exports